<template>
  <div id="pageTable" class="mainView">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-btn @click="createVOC()" color="primary">VOC 등록</v-btn>
          <v-flex  xs2 sm1>
          </v-flex>
          <v-card>
             <v-toolbar card color="white">
              <div class="flex xs12 sm2">
                <v-select
                        :items="[{
                          text: '요청자이름',
                          value: 'requestUserName'
                        },
                        {
                          text: '조치상태',
                          value: 'state'
                        }]"
                        name="header"
                        v-model="searchFormModel.filter"
                        label="header"
                ></v-select>
              </div>

                <div class="flex xs12 sm2" v-show="searchFormModel.filter === 'state'">
                 <v-select
                         :items="vocState"
                         label="선택"
                         item-text="text"
                         item-value="state"
                         single-line
                         v-model="searchFormModel.filterText"
                 >
                 </v-select>
                </div>
               <v-text-field
                       v-show="searchFormModel.filter !== 'state'"
                       flat
                       solo
                       prepend-icon="search"
                       placeholder="Type something"
                       v-model="searchFormModel.filterText"
                       hide-details
                       class="hidden-sm-and-down"
                       @keyup.enter="searchFilter"
               ></v-text-field>
               <v-btn icon @click="searchFilter">
                 <v-icon>filter_list</v-icon>
               </v-btn>
             </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="complex.items"
                :rows-per-page-items="[10,25,50]"
                class="elevation-1"
                item-key="id"
                must-sort
                :total-items="totalItems"
                :loading="loading"
                :pagination.sync="pagination"
                >
                <template slot="items" slot-scope="props">           
                  <td class="text-sm-center"><a @click="openDetail(props.item.id)">{{ props.item.id }}</a></td>
                  <td class="text-sm-center">{{ props.item.title }}</td>
                  <td class="text-sm-center">{{ props.item.requestUserName }}</td>
                  <td class="text-sm-center">{{ changeVocStateText(props.item.state) }}</td>
                  <td class="text-sm-center">{{ props.item.regDate }}</td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VocState from '@/api/vocState';

export default {
  data () {
    return {
      pagination: {
        sortBy: 'id',
        descending: true,
        rowsPerPage: 10,
        page: 1
      },
      searchFormModel: {
          filter: 'requestUserName',
          filterText: ''
      },
      vocState: VocState,
      last: "true",
      totalItems: 0,
      loading: true,
      prevData: null,
      complex: {
        headers: [
          {
            text: 'VOC 고유번호',
            value: 'id',
            align: 'center'
          },
          {
            text: '제목',
            value: 'title',
            align: 'center'
          },
          {
            text: '요청자이름',
            value: 'requestUserName',
            align: 'center'
          },
          {
            text: '조치상태',
            value: 'state',
            align: 'center'
          },
          {
            text: '등록일시',
            value: 'regDate',
            align: 'center'
          }
        ],
        items: []
      }
    };
  },
  watch: {
    pagination: {
      handler () {
        if (top.getApp.prevPageName === 'VocPage') {
          if(top.getApp.prevPagination != null) {
            this.pagination = top.getApp.prevPagination;
          }

          if(top.getApp.prevSearchFormModel != null) {
            this.searchFormModel = top.getApp.prevSearchFormModel;
          }

          top.getApp.clearPrevData();
        }

        this.banbanCreated();
      },
      deep: true
    },
    'searchFormModel.filter' () {
      this.searchFormModel.filterText = '';
    }
  },
  mounted () {
    for (let i = 0; i < this.$parent.$children.length; i++) {
      if (this.$parent.$children[i].chkAutoReload != null) {
        this.$parent.$children[i].chkAutoReload();
      }
    }
  },
  methods: {
    banbanCreated () {
      this.loading = true;

      const parameters = {
        method: 'vocs',
        pageNum: this.pagination.page - 1,
        pageSize: this.pagination.rowsPerPage,
        sortName: this.pagination.sortBy,
        order: this.pagination.descending == true ? 'desc' : 'asc',
        filter: this.searchFormModel.filter,
        filterText: this.searchFormModel.filterText
      };
      this.$store.dispatch('banbanAPI', parameters)
        .then(({ data }) => {
          if (data.statusCode != null && data.statusCode != '200'){
            throw data.message;
          }

          this.complex.items = data.content;
          this.totalItems = data.totalElements;
          top.getApp.progress.dialog = false;
          this.loading = false;
        })
        .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
          top.getApp.progress.dialog = false;
          });
    },
    changeVocStateText (stateCode) {
      if (stateCode != null) {
        for (let i = 0; i < this.vocState.length; i++) {
          if (this.vocState[i].state === stateCode) {
            return this.vocState[i].text;
          }
        }
      } else {
        return '';
      }
    },
    createVOC () {
      this.$router.push('/voc/createVoc');
    },
    openDetail (id) {
      top.getApp.addPrevData('VocPage', this.pagination, this.searchFormModel);
      this.$router.push('/voc/vocDetail/' + id);
    },
    searchFilter () {
        this.banbanCreated();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/voc/Voc.vue